import AppLayout from "../../components/layouts/AppLayout";
import EmailConfirmationWelcome from "../../components/sessions/EmailConfirmationWelcome";
import { Box } from "@mui/material";

const EmailWelcomePage = () => {
  return (
    <AppLayout>
      <Box
        sx={{
          display: "flex",
          minHeight: "60vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EmailConfirmationWelcome />
      </Box>
    </AppLayout>
  );
};
export default EmailWelcomePage;
